
import {
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';


import { EditCellDefault } from './edit-cell-default';

@Component({
  selector: 'table-cell-custom-editor',
  template: ` <ng-template #dynamicTarget></ng-template> `,
  standalone: false
})
export class CustomEditComponent extends EditCellDefault implements AfterViewInit, OnDestroy {
  public customComponent: any;
  @ViewChild('dynamicTarget', { read: ViewContainerRef })
  public dynamicTarget!: ViewContainerRef;

  constructor(private resolver: ComponentFactoryResolver) {
    super();
  }

  public ngAfterViewInit() {
    if (this.cell && !this.customComponent && this.dynamicTarget) {
      const componentFactory = this.resolver.resolveComponentFactory(
        this.cell.getColumn().editor.component
      );
      this.customComponent =
        this.dynamicTarget.createComponent(componentFactory);

      // set @Inputs and @Outputs of custom component
      this.customComponent.instance.cell = this.cell;
      this.customComponent.instance.inputClass = this.inputClass;
      this.customComponent.instance.onStopEditing.subscribe(() =>
        this.onStopEditing()
      );
      this.customComponent.instance.onEdited.subscribe((event: any) =>
        this.onEdited(event)
      );
      this.customComponent.instance.onClick.subscribe((event: any) =>
        this.onClick(event)
      );
    }
  }

  public ngOnDestroy() {
    if (this.customComponent) {
      this.customComponent.destroy();
    }
  }
}
